import { Fragment } from 'react';
import { Link } from '@hc/redux-saga-router-plus';
import { Dialog } from 'legacy/components/Dialog';

import ForecastSection from 'legacy/components/ForecastSection';
import ChartButton from 'legacy/components/ChartButton';

import { PropertyExplorerCharts as chartTheme } from 'legacy/css-modules';

const PropertyExplorerForecastChartButton = ({
  chartModal,
  forecastOneYear,
  forecastThreeYear,
  isActive,
  onClose,
  onClick
}) => {
  if (!isActive) return null;
  return (
    <Fragment>
      <Link
        options={{ inherit: true }}
        query={{ chartModal: 'forecastChart' }}
        className={chartTheme.LinkButton}
        onClick={onClick}
      >
        <ChartButton title={'HouseCanary Forecast'}>
          <div className={chartTheme.ChartButtonText}>
            1 year:
            <b>
              {' '}
              {forecastOneYear && forecastOneYear.zipTsOneYear
                ? forecastOneYear.zipTsOneYear
                : 'Not Enough Data'}
            </b>{' '}
            (zip),
            <b>
              {' '}
              {forecastOneYear && forecastOneYear.blockTsOneYear
                ? forecastOneYear.blockTsOneYear
                : 'Not Enough Data'}
            </b>{' '}
            (block)
          </div>
          <div className={chartTheme.ChartButtonText}>
            3 year:
            <b>
              {' '}
              {forecastThreeYear
                ? forecastThreeYear.zipTsOneYear
                : 'Not Enough Data'}
            </b>{' '}
            (zip)
          </div>
        </ChartButton>
      </Link>
      <Dialog
        theme={chartTheme}
        active={chartModal === 'forecastChart'}
        title={'HouseCanary Forecast'}
        onClose={onClose}
        closeButton
      >
        <ForecastSection />
      </Dialog>
    </Fragment>
  );
};

export default PropertyExplorerForecastChartButton;
